import clientLogo from '../assets/Logo/Logo.svg';

import AdminIcon from '../assets/Role Icon/adminIcon.svg';
import AssistanceIcon from '../assets/Role Icon/AssistanceIcon.svg';

import cancelIcon from '../assets/RequestIcon/Cancel.svg';
import sendIcon from '../assets/RequestIcon/Send.svg';
import eyeIcon from '../assets/RequestIcon/eyeIcon.svg';

const Images = {
  clientLogo,
  AdminIcon,
  AssistanceIcon,
  cancelIcon,
  sendIcon,
  eyeIcon
};

export default Images;
